"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _CarouselSlides = _interopRequireDefault(require("./CarouselSlides"));

var _CarouselPaginator = _interopRequireDefault(require("./CarouselPaginator"));

(function () {
  var enterModule = require('react-hot-loader').enterModule;

  enterModule && enterModule(module);
})();

var Carousel =
/*#__PURE__*/
function (_PureComponent) {
  (0, _inherits2.default)(Carousel, _PureComponent);

  function Carousel(props) {
    var _this;

    (0, _classCallCheck2.default)(this, Carousel);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(Carousel).call(this, props)); // TODO: slide changes cause a very quick flicker when clicking on pagination for non-subsequent pages on initial load

    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "_onPageClick", function (index) {
      _this._goToIndex(index);
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "_onPrevious", function () {
      _this._goToIndex(_this.state.currentIndex - 1);
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "_onNext", function () {
      _this._goToIndex(_this.state.currentIndex + 1);
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "_clearSlideShownTimeout", function () {
      if (_this._slideShownTimeout) {
        clearTimeout(_this._slideShownTimeout);
      }
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "_goToIndex", function (index) {
      if (_this._isTransitioning) {
        return;
      }

      if (_this.props.transition !== 'none') {
        _this._isTransitioning = true;
      }

      var newIndex;

      if (index < 0) {
        newIndex = _this._totalSlides - 1;
      } else if (index > _this._totalSlides - 1) {
        newIndex = 0;
      } else {
        newIndex = index;
      }

      _this.setState({
        currentIndex: newIndex
      });
    });
    _this._TRANSITION_TIME = 250;
    _this._isTransitioning = false;
    _this.state = {
      currentIndex: props.startIndex
    };
    return _this;
  }

  (0, _createClass2.default)(Carousel, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      var _this2 = this;

      var _this$props = this.props,
          onBeforeSlideShown = _this$props.onBeforeSlideShown,
          onAfterSlideShown = _this$props.onAfterSlideShown;
      var currentIndex = this.state.currentIndex;
      var previousIndex = prevState.currentIndex;

      if (previousIndex !== currentIndex) {
        this._clearSlideShownTimeout();

        if (onBeforeSlideShown) {
          onBeforeSlideShown(currentIndex, previousIndex);
        }

        this._slideShownTimeout = setTimeout(function () {
          _this2._isTransitioning = false;

          if (onAfterSlideShown) {
            onAfterSlideShown(currentIndex, previousIndex);
          }
        }, this._TRANSITION_TIME);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this._clearSlideShownTimeout();
    }
  }, {
    key: "_renderSlides",
    value: function _renderSlides(slides) {
      this._totalSlides = slides.props.children.length;
      var _this$props2 = this.props,
          showArrows = _this$props2.showArrows,
          showDots = _this$props2.showDots,
          lazyLoad = _this$props2.lazyLoad,
          preload = _this$props2.preload;
      var internalShowArrows = this._totalSlides > 1 ? showArrows : false;
      return (0, _react.cloneElement)(slides, {
        currentIndex: this.state.currentIndex,
        showArrows: internalShowArrows,
        showDots: showDots,
        lazyLoad: lazyLoad,
        preload: preload,
        onPreviousClick: this._onPrevious,
        onNextClick: this._onNext,
        onDotClick: this._goToIndex
      });
    }
  }, {
    key: "_renderPagination",
    value: function _renderPagination(items) {
      if (items.length < 2) {
        return null;
      }

      return (0, _react.cloneElement)(items, {
        onItemClick: this._onPageClick,
        currentIndex: this.state.currentIndex
      });
    }
  }, {
    key: "_renderChildren",
    value: function _renderChildren() {
      var _this3 = this;

      return _react.Children.map(this.props.children, function (child) {
        if (child && child.type && (child.type === _CarouselSlides.default || child.type.displayName === 'CarouselSlides')) {
          return _this3._renderSlides(child);
        } else if (child && child.type && (child.type === _CarouselPaginator.default || child.type.displayName === 'CarouselPaginator')) {
          return _this3._renderPagination(child);
        } else {
          return null;
        }
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
          className = _this$props3.className,
          transition = _this$props3.transition;
      var classes = (0, _classnames.default)('Carousel', "Carousel-transition-".concat(transition), className);
      return _react.default.createElement("div", {
        className: classes
      }, this._renderChildren());
    }
  }, {
    key: "__reactstandin__regenerateByEval",
    // @ts-ignore
    value: function __reactstandin__regenerateByEval(key, code) {
      // @ts-ignore
      this[key] = eval(code);
    }
  }]);
  return Carousel;
}(_react.PureComponent);

exports.default = Carousel;
(0, _defineProperty2.default)(Carousel, "propTypes", {
  /** Additional class(es) to add to the component. */
  className: _propTypes.default.string,

  /** The content to insert into the carousel. */
  children: _propTypes.default.oneOfType([_propTypes.default.element, _propTypes.default.node, _propTypes.default.arrayOf(_propTypes.default.element), _propTypes.default.arrayOf(_propTypes.default.node)]).isRequired,

  /** Whether to show the arrow navigation. If only one image exists it will automatically get set to false, regardless of the value passed here. */
  showArrows: _propTypes.default.bool,

  /** Whether to show the dot navigation. */
  showDots: _propTypes.default.bool,

  /** Whether to lazy load carousel slide content. */
  lazyLoad: _propTypes.default.bool,

  /** Whether to preload the previous and next images when lazy loading. */
  preload: _propTypes.default.bool,

  /** The transition animation between current and previous/next slide. */
  transition: _propTypes.default.oneOf(['none', 'slide', 'fade']),

  /** The initially selected slide based on a 0 index. */
  startIndex: _propTypes.default.number,

  /** Method to execute before the next slide is shown.  Receives the new index as well as the previous index. */
  onBeforeSlideShown: _propTypes.default.func,

  /** Method to execute after the next slide has shown.  Receives the new index as well as the previous index. */
  onAfterSlideShown: _propTypes.default.func
});
(0, _defineProperty2.default)(Carousel, "defaultProps", {
  showArrows: true,
  preload: true,
  lazyLoad: true,
  transition: 'none',
  startIndex: 0
});
;

(function () {
  var reactHotLoader = require('react-hot-loader').default;

  var leaveModule = require('react-hot-loader').leaveModule;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(Carousel, "Carousel", "/Users/mprzybylski/Work/SpotHero/fe-ui/src/Carousel/Carousel.jsx");
  leaveModule(module);
})();

;